import { OnlineSalesUnauthenticated } from 'gw-edge-client';
import { selector } from 'recoil';
import { jobInfoAtom } from '../atoms/jobInfoAtom';
import { isLoggedOnSelector } from './isLoggedOnSelector';
import type { TypeKeyDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/activationflow/dto';
import { getOnsaCurrentProductSelector } from './getOnsaCurrentProductSelector';
import { opcInfoAtom } from '../atoms/opcInfoAtom';

export const yearlyMileageOptionsSelector = selector<TypeKeyDTO[]>({
    key: 'yearlyMileageOptions',
    get: async ({ get }) => {
        const { jobNumber, sessionId } = get(jobInfoAtom);
        const currentProduct = get(getOnsaCurrentProductSelector);
        const { coverableId } = get(opcInfoAtom);
        if (!currentProduct && coverableId === '') return [];
        const isLoggedOn = get(isLoggedOnSelector);

        if (!currentProduct)
            return await OnlineSalesUnauthenticated.getYearlyMileageOptions(
                jobNumber,
                coverableId,
                sessionId,
                !isLoggedOn
            );
        return await OnlineSalesUnauthenticated.getYearlyMileageOptions(
            jobNumber,
            currentProduct.fixedId,
            sessionId,
            !isLoggedOn
        );
    }
});
